export default "__VITE_ASSET__DyHd11Zn__"